import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.7912 10.9948H6.62124L9.50124 8.11484C9.89124 7.72484 9.89124 7.09484 9.50124 6.70484C9.31441 6.51759 9.06076 6.41235 8.79624 6.41235C8.53172 6.41235 8.27807 6.51759 8.09124 6.70484L3.50124 11.2948C3.11124 11.6848 3.11124 12.3148 3.50124 12.7048L8.09124 17.2948C8.48124 17.6848 9.11124 17.6848 9.50124 17.2948C9.89124 16.9048 9.89124 16.2748 9.50124 15.8848L6.62124 12.9948H19.7912C20.3412 12.9948 20.7912 12.5448 20.7912 11.9948C20.7912 11.4448 20.3412 10.9948 19.7912 10.9948Z",
		fill: "currentColor"
	})
});
export default SvgArrowBack;
